module.exports = __webpack_public_path__ + "img/fin-new-watchlist.295e3390.svg";